module.exports = __webpack_public_path__ + "static/Top-d300eb0ef93c9ea0b34f5d712bcf0ccd.jpeg";